import { useEffect } from 'react';

// Zolang er ergens een pop-up ("modal") open staat, mag de pagina erachter niet scrollen
// (ook niet in de app, waar een eigen container scrolt i.p.v. het document). Eén keer
// gebruikt in App.js, geldt dus voor ALLE pop-ups van de site en de app.
//
// - Zet de klasse "modal-open" op <html> zolang er een pop-up in de DOM staat (CSS in
//   appTheme.css blokkeert dan het scrollen van document en app-container).
// - Een veeg op de donkere achtergrond, of op een pop-up-deel dat zelf niet kan scrollen,
//   wordt tegengehouden (iOS laat anders de pagina erachter nog meebewegen).
const OVERLAY_SELECTOR = '.modal-overlay, .profile-menu-modal-overlay, .pdf-viewer-overlay, .contactmsg-overlay, .notifprefs-overlay';

const canScrollInside = (target, overlay) => {
  let el = target;
  while (el && el !== overlay && el.nodeType === 1) {
    const overflowY = window.getComputedStyle(el).overflowY;
    if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) return true;
    el = el.parentElement;
  }
  return false;
};

export default function useModalScrollLock() {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const root = document.documentElement;
    let locked = false;
    let raf = 0;

    const update = () => {
      raf = 0;
      const open = !!document.querySelector(OVERLAY_SELECTOR);
      if (open === locked) return;
      locked = open;
      if (open) {
        // Geen verspringende pagina op computers doordat de scrollbalk verdwijnt.
        const scrollbar = window.innerWidth - root.clientWidth;
        const gutterStable = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('scrollbar-gutter', 'stable');
        if (scrollbar > 0 && !gutterStable) root.style.paddingRight = `${scrollbar}px`;
      } else {
        root.style.paddingRight = '';
      }
      root.classList.toggle('modal-open', open);
    };
    const schedule = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };

    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    update();

    const onTouchMove = (e) => {
      if (!locked) return;
      const target = e.target;
      const overlay = target && target.closest ? target.closest(OVERLAY_SELECTOR) : null;
      if (!overlay) {
        if (e.cancelable) e.preventDefault();
        return;
      }
      if (!canScrollInside(target, overlay) && e.cancelable) e.preventDefault();
    };
    document.addEventListener('touchmove', onTouchMove, { passive: false });

    return () => {
      observer.disconnect();
      document.removeEventListener('touchmove', onTouchMove);
      if (raf) window.cancelAnimationFrame(raf);
      root.classList.remove('modal-open');
      root.style.paddingRight = '';
    };
  }, []);
}
